
class ModifierRatesDetailCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;
    private priceLabel:MUILabel = null;
    private taxButton:MUIButton = null;
    private specificRateTextfield:MUITextField = null;

    private timer:MIOTimer = null;

    private ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
    private cf = MUIWebApplication.sharedInstance().delegate.currencyFormatter as MIONumberFormatter;
    private nf = MUIWebApplication.sharedInstance().delegate.numberFormatter as MIONumberFormatter;

    awakeFromHTML()
    {
        this.nameLabel = MUIOutlet(this, "rate-name-lbl", "MUILabel");
        this.priceLabel = MUIOutlet(this, "base-price-lbl", "MUILabel");

        this.taxButton = MUIOutlet(this, 'tax-btn', 'MUIButton');
        this.taxButton.setAction(this, function (){            
            this.showSelectTaxViewController(this.taxButton);
        });

        this.specificRateTextfield = MUIOutlet(this, "specific-rate-tf", "MUITextField");
        this.specificRateTextfield.formatter = this.cf;
        this.specificRateTextfield.setOnChangeText(this, function(control, value){
            if (this.timer != null) this.timer.invalidate();
            this.timer = MIOTimer.scheduledTimerWithTimeInterval(600, false, this, function(timer:MIOTimer){
                this.timer = null;

                value = value.length > 0 ? value : null;
                this.updateSpecificRate(value);
            });
        });
    }

    private _rate:Rate = null;
    set rate(r:Rate){
        this._rate= r;
    }

    private _modifier:ProductModifier = null;
    set modifier(i:ProductModifier){
        this._modifier = i;
        // this.imageView.setImage(i.image?.url);
        this.nameLabel.text = i.name;
        this.priceLabel.text = i.priceFormat;
        if(i.productModifierRates?.allObjects.length > 0) this.loadModifierRate(i);
    }

    private _modifierRate:ProductModifierRate = null;
    set modifierRate(i:ProductModifierRate){
        this._modifierRate = i;
        if(i.price) this.specificRateTextfield.text = i.price;
        if(i.tax) this.taxButton.title = i.tax.name;
    }

    private showSelectTaxViewController(button:MUIButton) {
        let vc = AppHelper.sharedInstance().showCustomSelectViewControllerFromView(button, 'Tax', 'name', null, this, function(controller, object:Tax){
            //returns object, test value then update Tax

            button.title = (object) ? object.valueForKey('name') : MIOLocalizeString("TAX_RATE", "TAX RATE");
            this.updateTax(object);

        }, true );        
    }

    private loadModifierRate(item:ProductModifier) {
        if (this._modifierRate != null) return;

        //compares all related RATES of object in current cell to the currently selected RATE
        for (let i = 0; i < item.productModifierRates.allObjects.length; i++) {
            if (item.productModifierRates.allObjects[i].rate.identifier == this._rate?.identifier){
                this.modifierRate = item.productModifierRates.allObjects[i];
                return; //when you find a match return, there should ONLY ever be one match
            }
        }
    }

    private updateSpecificRate(value:string){
        if (this._modifierRate){
            this._modifierRate.price = value; //this.cf.numberFromString(value);
            this.testProductModifierRateForDelete();
        } else {
            if (value){
                this._modifierRate = MIOEntityDescription.insertNewObjectForEntityForName("ProductModifierRate", this.ad.managedObjectContext) as ProductModifierRate;
                this._modifierRate.identifier = new MIOUUID().UUIDString;
                this._modifierRate.productModifier = this._modifier;
                this._modifierRate.rate = this._rate;
                this._modifierRate.price = value; //this.cf.numberFromString(value);
                this.ad.managedObjectContext.save();
            }
        }
    }

    private updateTax(value:Tax) {
        if (this._modifierRate){
            this._modifierRate.tax = value;
            this.testProductModifierRateForDelete();
        } else {
            if(value){
                this._modifierRate = MIOEntityDescription.insertNewObjectForEntityForName("ProductModifierRate", this.ad.managedObjectContext) as ProductModifierRate;
                this._modifierRate.identifier = new MIOUUID().UUIDString;
                this._modifierRate.productModifier = this._modifier;
                this._modifierRate.rate = this._rate;
                this._modifierRate.tax = value;
                this.ad.managedObjectContext.save();
            }
        }
    }

    private testProductModifierRateForDelete(){
        if(!this._modifierRate?.price && !this._modifierRate?.tax){
            DBHelper.deleteObjectFromMainContext(this._modifierRate, true);
            this._modifierRate = null;
        }
    }

}